import { Form } from '@form/Form';
import FormInput from '@form/FormInput';
import { Blockquote, Button } from '@ui';
import moment, { Moment } from 'moment';
import React, { useState } from 'react';
import { useApi } from '../../../hooks/useApi';
import { SpaceBlocking } from '../types';

interface Props {
    blocking: Partial<SpaceBlocking>;
    callback?: (newBlocking: SpaceBlocking) => void;
}

export const SpaceBlockingCopyWizard: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ blocking, callback }) => {
    const api = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<{ message: string; colliding_items: any[] }>();
    const start = moment(blocking.start);

    const handleCustomDate = (data: any) => {
        return handleCopyBlocking(moment(data.date));
    };

    const handleCopyBlocking = (date: Moment) => {
        setIsLoading(true);
        return api({
            url: `space/blocking/${blocking.id}/copy`,
            method: 'POST',
            data: { date },
            muted: true,
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback?.(data),
            onFailure: ({ data }) => setError(data)
        });
    };

    return (
        <>
            <Blockquote>
                Deine Sperrung wird kopiert und das Startdatum auf dein Datum deiner Wahl gesetzt. Alle anderen
                Einstellungen bleiben bestehen.
            </Blockquote>

            {error && (
                <Blockquote color="warning">
                    {error.message}
                    <ul>
                        {error.colliding_items?.map((item) => (
                            <li key={`${item.type}_${item.id}`}>
                                {item.title} (am {moment(item.start).format('ll')})
                            </li>
                        ))}
                    </ul>
                </Blockquote>
            )}
            <Button
                className="mt-3"
                isLoading={isLoading}
                onPress={() => handleCopyBlocking(start.clone().add(1, 'day'))}
            >
                morgen ({start.clone().add(1, 'day').format('ll')})
            </Button>
            <Button
                className="mt-2"
                isLoading={isLoading}
                onPress={() => handleCopyBlocking(start.clone().add(1, 'week'))}
            >
                nächste Woche ({start.clone().add(1, 'week').format('ll')})
            </Button>
            <Button
                className="mt-2"
                isLoading={isLoading}
                onPress={() => handleCopyBlocking(start.clone().add(1, 'month'))}
            >
                nächsten Monat ({start.clone().add(1, 'month').format('ll')})
            </Button>
            <Button
                className="mt-2"
                isLoading={isLoading}
                onPress={() => handleCopyBlocking(start.clone().add(1, 'year'))}
            >
                nächstes Jahr ({start.clone().add(1, 'year').format('ll')})
            </Button>
            <Form onSubmit={handleCustomDate}>
                <FormInput.DatePicker
                    label="Datum auswählen"
                    name="date"
                    contentRight={
                        <Button type="submit" auto isLoading={isLoading}>
                            Kopieren
                        </Button>
                    }
                    contentRightStyling={false}
                />
            </Form>
        </>
    );
};
